'use client';
import { useQuery } from '@tanstack/react-query';
import { ReactNode, useEffect } from 'react';
import { useUserStore } from '../../stores/UserStore';
import { checkAuth } from '../../backend/api/auth';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { user, logout } = useUserStore();
  const { data, error } = useQuery({ queryKey: ['auth-check'], queryFn: checkAuth, enabled: !!user, retry: false, refetchInterval: 60 * 1000});

  useEffect(() => {
    if (error && user) {
        logout()
    }
  }, [error, user, logout]);

  return <>{children}</>;
} 